import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'flex-start',
    padding: theme.spacing(2, 0),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(4, 0, 0),
    },
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(9, 0, 0),
    },
    '&>svg': {
      width: 80,
    },
  },
  mainContainer: {
    minHeight: '100vh',
    display: 'flex',
    flexFlow: 'column wrap',
    justifyContent: 'center',
    flexGrow: 1,
  },
  root: {
    padding: theme.spacing(0, 3),
    flexDirection: 'column-reverse',
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(8, 14),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(8.75, 8),
      flexDirection: 'row',
      alignItems: 'stretch',
    },
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(8.75, 12),
    },
  },
  formCta: {
    display: 'flex',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(1),
    },
    '&>*': {
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
      width: '45%',
      [theme.breakpoints.up('sm')]: {
        width: 'auto',
      },
    },
  },
  textWrapper: {
    '[lang=ar] &': {
      paddingLeft: theme.spacing(3),
    },
    maxWidth: '100%',
    marginTop: theme.spacing(5),
    alignSelf: 'flex-start',
    [theme.breakpoints.down('xs')]: {
      animation: '$slideUpAnimation 500ms ease-in-out',
      animationDelay: '1000ms',
    },
    [theme.breakpoints.up('sm')]: {
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      marginTop: theme.spacing(6),
      alignSelf: 'center',
    },
    [theme.breakpoints.up('md')]: {
      marginRight: 'auto',
    },
  },
  imgWrapper: {
    display: 'flex',
    position: 'relative',
    minWidth: '50%',
    minHeight: 600,
    overflow: 'visible',
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%',
      minHeight: '45vh',
      zIndex: theme.zIndex.xRayWrapper,
      alignItems: 'flex-end',
    },
    [theme.breakpoints.between('sm', 'sm')]: {
      padding: theme.spacing(0, 6),
      minHeight: '45vh',
      alignItems: 'flex-end',
    },
    '&>object': {
      width: '100%',
    },
  },
  title: {
    margin: theme.spacing(3, 0),
    [theme.breakpoints.down('xs')]: {
      maxWidth: '100%',
    },
  },
  bannerImage: {
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    width: '100%',
    minHeight: 400,
    '& img': {
      objectFit: 'contain',
      backgroundClip: 'text',
    },
    '& object': {
      objectFit: 'contain',
      backgroundClip: 'text',
    },
  },
  '@keyframes slideUpAnimation': {
    '0%': {
      transform: 'translateY(20px)',
      opacity: 0,
    },
    '20%': {
      opacity: 1,
    },
    '100%': {
      transform: 'translateY(0px)',
      opacity: 1,
    },
  },
}))
